import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import {  SpecialistSignUpComponent } from './components/sign-up/sign-up.component';
import { SpecialistSignInComponent } from './components/sign-in/sign-in.component';
import { MaterialModule } from 'src/app/_shared/module/material.module';
import { TermsComponent } from './components/sign-up/modal/terms/terms.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDirectiveModule } from 'src/app/core/directives/custom-directive.module';
import { PcvSignInComponent } from './components/pcv-sign-in/pcv-sign-in.component';
import { PcvSignUpComponent } from './components/pcv-sign-up/pcv-sign-up.component';
import { PcvForgotPasswordComponent } from './components/pcv-forgot-password/pcv-forgot-password.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SpecialistForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { AdminSignInComponent } from './components/admin-sign-in/admin-sign-in.component';
import { AdminForgotPasswordComponent } from './components/admin-forgot-password/admin-forgot-password.component';
import { AdminChangeEmailComponent } from './components/admin-change-email/admin-change-email.component';
import { SetupAccountComponent } from './components/setup-account/setup-account.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { AutoSsoComponent } from './components/auto-sso/auto-sso.component';
// import { IconModule } from '@visurel/iconify-angular';
// import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { SpecialtySharedModule } from 'src/app/_shared/modules/specialty-shared.module';
import { SharedModalsModule } from 'src/app/components/_shared/modals/shared-modals.module';

@NgModule({
  declarations: [SpecialistSignUpComponent,
     SpecialistSignInComponent,
     SpecialistForgotPasswordComponent,
     PcvSignInComponent,
     PcvSignUpComponent,
     PcvForgotPasswordComponent,
     ResetPasswordComponent,
     TermsComponent,
     AdminSignInComponent,
    AdminForgotPasswordComponent,
    AdminChangeEmailComponent,
    SetupAccountComponent,
    AuthCallbackComponent,
    AutoSsoComponent
     ],

  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    CustomDirectiveModule,
    NgxMaskDirective,
    SpecialtySharedModule,
    SharedModalsModule
    // IconModule,
    // TextMaskModule
  ],
  providers: [provideNgxMask()],
})
export class AuthenticationModule { }
